import React, { useEffect } from 'react'
import api, { ISpaceType } from '@api'
import EvoSelect from './EvoSelect'

interface SpaceTypeSelectProps {
  value: ISpaceType | null
  onChange: (spaceType: any) => void
  itemDisabled?: (spaceType: ISpaceType) => boolean
}

export default function SpaceTypeEvoSelect({ value, onChange }: SpaceTypeSelectProps) {
  const spaceTypes: ISpaceType[] = useSpaceTypes()

  const formatItems = (list: any[] | undefined) => {
    const formattedItems: any = list?.map((item: any) => {
      return {
        label: item?.displayName,
        value: item?.name,
        interactivityType: item?.interactivityType,
      }
    })
    return formattedItems
  }

  return (
    <EvoSelect
      isSearchable
      value={{ label: value?.displayName, value: value?.id }}
      options={formatItems(spaceTypes)}
      onChange={(spaceType: any) =>
        onChange({
          displayName: spaceType.label,
          name: spaceType.value,
          interactivityType: spaceType.interactivityType,
        })
      }
      size="small"
    />
  )
}

let persistedState: ISpaceType[] = []

export function useSpaceTypes(): ISpaceType[] {
  const [spaceTypes, setSpaceTypes] = React.useState<ISpaceType[]>(persistedState)

  useEffect(() => {
    api.company.spaceTypes().then((spaceTypes) => setSpaceTypes(spaceTypes))
  }, [])

  useEffect(() => {
    // Cache initial list
    if (!persistedState.length && spaceTypes.length) {
      persistedState = spaceTypes
    }
  })

  return spaceTypes
}
